<template>
  <div class="card_v1">
    <div class="card_inner">
      <div class="card_head">
        <h2>Share of Sentiment</h2>
      </div>

      <div class="card_content" :class="{ card_content_blur: isZero() }">
        <template v-if="isZero()">
          <div class="no_data_for_chart">{{ noDataMessage }}</div>
        </template>
        <div :class="{ blur_div: isZero() }">
          <highcharts
            ref="share_sentiment_chart"
            :options="shareSentiment"
          ></highcharts>
          <ul
            id="share_sentiment_item_highlight"
            class="ds_item_highlight ds_item_highlight_value"
          >
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NO_DATA_AVAILABLE } from '@common/constants/messages'

import { mapGetters } from 'vuex'

import highcharts from "@ui/Highcharts";
export default {
  components: {
    highcharts
  },
  props: {
    articles_sentiments_with_count: {}
  },
  data () {
    return {
      noDataMessage: NO_DATA_AVAILABLE,

      shareSentiment: {
        credits: {
          enabled: false
        },
        chart: {
          height: 365,
          type: 'pie',
          spacingBottom: 0,
          spacingTop: 0,
          spacingLeft: 0,
          spacingRight: 0,
          marginTop: 0,
          marginLeft: 0,
          marginRight: 0,

          style: {
            fontFamily: "'Source Sans Pro', sans-serif"
          },
          events: {
            load: function () {
              const chart = this
              $('#facebook_item_highlight').empty()
              $(chart.series[0].data).each(function (i, serie) {
                console.debug('Share of Sentiment', serie)
                $(
                  '<li><span style="background: ' +
                    serie.color +
                    ';" class=" color_box"></span> <span>' +
                    serie.name +
                    '</span><span  class="value">' +
                    serie.y +
                    '%</span></li>'
                )
                  .click(function () {
                    if (serie.visible) {
                      serie.setVisible(false)
                      $(this).addClass('disabled')
                    } else {
                      serie.setVisible(true)
                      $(this).removeClass('disabled')
                    }
                  })
                  .appendTo('#share_sentiment_item_highlight')
              })
            }
          }
        },
        plotOptions: {
          series: {
            borderWidth: 0
          },
          pie: {
            // innerSize: '60%',
            shadow: false,
            center: ['50%', '50%'],
            dataLabels: false
          }
        },
        colors: ['#6ee5a5', '#e6ce6e', '#e6766e'],

        tooltip: {
          headerFormat:
            '<div class="chart_tooltip engagement_tooltip"><h4>Sentiment Percentage</h4>',
          pointFormat: '<p class="engagement_point"><span>{point.y}</span></p>',
          footerFormat: '</div>',
          backgroundColor: null,
          shadow: false,
          useHTML: true,
          borderWidth: 0,
          crosshairs: {
            width: 50,
            color: '#fafafa'
          }
        },
        title: {
          text: ''
        },
        series: [
          {
            size: '80%',
            innerSize: '55%',
            data: [
              ['Postive', 10],
              ['Neutral', 40],
              ['Negative', 60]
            ]
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['getInsightsSentimentsCount'])
  },
  created () {
    console.debug(this.articles_sentiments_with_count.percentage)
    if (!this.isZero()) {
      this.shareSentiment.series[0].data = [
        [
          'Postive',
          parseInt(this.articles_sentiments_with_count.percentage.positive)
        ],
        [
          'Neutral',
          parseInt(this.articles_sentiments_with_count.percentage.neutral)
        ],
        [
          'Negative',
          parseInt(this.articles_sentiments_with_count.percentage.negative)
        ]
      ]
    }
  },
  methods: {
    isZero () {
      if (
        parseInt(this.articles_sentiments_with_count.percentage.positive) +
          parseInt(this.articles_sentiments_with_count.percentage.neutral) +
          parseInt(this.articles_sentiments_with_count.percentage.negative) ==
        0
      ) {
        return true
      }
      return false
    }
  }
}
</script>
